import { render, staticRenderFns } from "./RiskScoreTag.vue?vue&type=template&id=1a80b947&scoped=true"
import script from "./RiskScoreTag.vue?vue&type=script&lang=js"
export * from "./RiskScoreTag.vue?vue&type=script&lang=js"
import style0 from "./RiskScoreTag.vue?vue&type=style&index=0&id=1a80b947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a80b947",
  null
  
)

export default component.exports